import 'apps/billing/styles/components/credit-card-manager.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import withData from 'util/hoc/with-data';
import Query from 'library/util/query';
import Loading from 'components/loading';

import PlusSvg from 'library/icons/plus.svg';
import NewCreditCard from 'apps/billing/components/new-credit-card';
import CreditCard from 'apps/billing/components/credit-card';

const AddCreditCardButton = (props) => (
  <div {...props} className="billing-add-credit-card">
    <PlusSvg /> New Card
  </div>
);

class CreditCardManager extends React.Component {
  static propTypes = {
    credit_cards: PropTypes.array,
    graph_data: PropTypes.object.isRequired,
    graph_loading: PropTypes.bool,
    reload_graph: PropTypes.func
  }

  mapPaymentMethods = (card, index) => (
    <CreditCard
      reload_graph={this.props.reload_graph}
      creditCards={resolve(this.props.graph_data, 'credit_cards', [])}
      key={index}
      index={index}
      {...card}
    />
  )

  render() {
    const {
      graph_data,
      graph_loading
    } = this.props;

    return graph_loading ? ( <Loading /> ) : (
      <div className="billing-credit-cards">
        {
          resolve(graph_data, 'credit_cards', []).map(this.mapPaymentMethods)
        }
        <NewCreditCard {...this.props} component={AddCreditCardButton} />
      </div>
    );
  }
}

CreditCardManager.query = async (token, { limit = 15 }) => (
  await Query(`
      query {
        credit_cards (
          limit: ${limit}
        ) {
            results {
                address_city
                address_country
                address_line1
                address_line2
                address_state
                address_zip
                brand
                cardholder_name
                default_payment_method
                exp_month
                exp_year
                funding
                last4
                source_id
            },
            pagination {
              limit
              offset
              total
            }
        }
      }
    `)
);

CreditCardManager.parseQueryData = (data) => ({
  credit_cards: resolve(data, 'credit_cards/results', []),
  pagination: resolve(data, 'credit_cards/pagination')
});

export default withData(CreditCardManager);
